import React from "react";
import { Link } from "react-router-dom";
import { logintext } from "../../Lang/fa/Login";
import ModalLogin from "../User/ModalLogin";
import { ShowCart } from "./UniBasket";
import userIcon from "../../assets/SMSVG/userIcon.svg";
import basketIcon from "../../assets/SMSVG/basketIcon.svg";

class UniProfileLogout extends React.Component{   
    render(){
        if(window.innerWidth > 850){
            return(
                <React.Fragment>
                    <div className="top-user">
                        <div className="icon">
                            <div
                            className="nav-link top-icon-cart "
                            onClick={this.props.userdata ? ShowCart : this.props.func}
                            >
                              <img className='nav-icon' src={basketIcon} alt='سبد خرید'/>
                              <div className="small-number">{this.props.count}</div>
                            </div>
                            <div
                            className="nav-link top-icon "
                            onClick={() => {
                                this.props.showProfile();
                                this.props.func();
                            }}
                            >
                              <img className='nav-icon' src={userIcon} alt='پروفایل'/>
                            </div>
                        </div>
                        <div className="text">
                            <div className="title ">برای تجربه بهتر</div>
                            <div className="sub-title ">
                                لطفا وارد حساب کاربری شوید
                            </div>
                        </div>
                    </div>
                    <div className="part">
                        <div className="link" onClick={this.props.setOpen }>
                            {logintext.enter} 
                        </div>
                    </div>
                </React.Fragment>
            )
        }else{
            return(
                <React.Fragment>
                <div className="top-user">
                  <div className="icon">
                
                    <div className="text">
                      <div className="title ">برای تجربه بهتر</div>
                      <div to="/user/login" className="sub-title ">
                        لطفا وارد حساب کاربری شوید
                      </div>
                    </div>
                  
                    <div
                      className="nav-link top-icon-cart "
                      onClick={this.props.userdata ? ShowCart : this.props.func}
                    >
                      <img className='nav-icon' src={basketIcon} alt='سبد خرید'/>
                      <div className="small-number">{this.props.count}</div>
                    </div>
                    <div
                      className="nav-link top-icon "
                      onClick={() => {
                        this.props.showProfile();
                        this.props.func();
                      }}
                    >
                      <span className="sub-title1" onClick={this.props.setOpen }>
                        <div className="link" >
                          {logintext.enter} 
                        </div> 
                      </span>
                      <img className='nav-icon' src={userIcon} alt='پروفایل'  onClick={this.props.setOpen }/>
                    </div>
                  </div>
                </div>
            </React.Fragment>
            )
        }
    }
}
export default UniProfileLogout;